import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./terms.css";
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
function TermsofServices() {
    const navigate = useNavigate();
    const [generalData, setgeneraldata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [htmlTerms, setHtmlTerms] = useState([])
    
    useEffect(() => {
        const fetchsetsData = async () => {
        try {
            const response = await apiService.getRequest('/general-settings');
            if(response && response.success === true){
                setgeneraldata(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }
        };
        fetchsetsData();
    }, []);

    useEffect(() => {
        const fetchsetsterms = async () => {
            setLoading(true)
        try {
            const response = await apiService.postRequest('/latest/terms');
            if(response && response.success === true){
                setHtmlTerms(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
        };
        fetchsetsterms();
    }, []);
    
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
    <Grid size={{xs:12}} container justifyContent="center" className="termsconditionmain">
        <Grid size={{md:10,xs:11}} container justifyContent="flex-start" alignItems="flex-start" flexDirection="column">
            {generalData && generalData.site_logo ? <img onClick={() =>{navigate("/")}} src={generalData.site_logo} alt=''/> :
                <img onClick={() =>{navigate("/")}} src={require("../../assets/logo.svg").default} alt=''/>
            }
            <h2>Terms and Conditions</h2>
            {loading ? 
            <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :<>
                <div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(htmlTerms.content) }} />
            </>}
        </Grid>
    </Grid>
  )
}

export default TermsofServices
